import { api } from '@services';

import Picture, { IPicture, IPictureApiModel } from '@models/Picture.model';

interface IPatchPictureVariables {
  id: string;
  name: string;
  uri?: string;
  file?: File;
  type: 'uri' | 'file';
}

const patchEquipmentPicture = async ({
  id,
  name,
  uri,
  file,
  type,
}: IPatchPictureVariables): Promise<IPicture> => {
  const formData = new FormData();

  formData.append('name', name);

  if (type) {
    formData.append('type', type);
  }

  if (type === 'file' && file) {
    formData.append('file', file);
  } else if (type === 'uri' && uri) {
    formData.append('uri', uri);
  }

  const { data: picture } = await api.patch<IPictureApiModel>(
    `/pictures/${id}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return Picture.fromApiModel(picture);
};

export { patchEquipmentPicture };
